import React, { Component } from "react";
import Modal from '@mui/material/Modal';

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MenuItem from '@mui/material/MenuItem';

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";

import * as ajax from "helpers/ajax";
import styles from "./index.module.css";

import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";
import { toPrice, toEuropeanDate } from "helpers/functions.js"
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon"
import { UPLOAD_PATH, STATUS_WORKER } from "constant.js";
import { ROLES } from "constant"


import GestioneManodopera from "layouts/gestione-operai/index.js"
import { newWorkerPrice } from "../../helpers/functions";


export default class ManodoperaCommessa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            workers: this.props.workers?this.props.workers:[],

            editWorker: null,

            openGestioneManodopera:false,
            selectedCommessa: null,
            selectedDate:null,

            searchFilter: "",

            chartData: [],


            workerDetail: {}
        };
    }

    componentDidMount = () => {
        let temp = {};

        this.props.workers.map((el) => {
            if (!el || !el.operaio) { return; }
            if (!temp[el.operaio.id]) {
                temp[el.operaio.id] = []
            }
            temp[el.operaio.id].push(el);
        })
        this.setState({ workerDetail: temp})
    }

    renderRigaWorker = (el, index) => {
        if (!el || !el.operaio) { return null; }
        
        let searchString = el.operaio.nome + " " + el.operaio.cognome;

        if (!searchString.toLowerCase().includes(this.state.searchFilter.toLowerCase()) && this.state.searchFilter) {
            return null
        }

        let price = toPrice(newWorkerPrice(el))
        let oreText = el.ore + "H";
        if (el.filler && el.filler > 0) {
            oreText += " + RISOLUZIONE " + el.filler + "H";
        }
        
        return (
            <tr key={"ordine-" + index}>
                <td><MDTypography variant="caption" fontWeight="medium">{el.operaio.nome} {el.operaio.cognome}</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{el.stato} {oreText}</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{toEuropeanDate(el.data)}</MDTypography></td>
                {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ? 
                    <td><MDTypography variant="caption" fontWeight="medium">{price}</MDTypography></td>
                :null}
                <td>
                    {this.state.data.stato != "finito" ?
                        <Grid container justifyContent={"flex-end"}>
                            <Grid item m={1}>
                                <MDButton color="success" iconOnly onClick={() => this.openDetail(el)}>
                                    <Icon>visibility</Icon>
                                </MDButton>
                            </Grid>
                            {[ROLES.segreteria].includes(global.user.ruolo) ? null :
                                <>
                                    <Grid item m={1}>
                                        <MDButton color="warning" iconOnly onClick={() => this.edit(el)}>
                                            <Icon>edit</Icon>
                                        </MDButton>
                                    </Grid>
                                    <Grid item m={1}>
                                        <MDButton color="error" iconOnly onClick={() => this.delete(el)}>
                                            <Icon>delete</Icon>
                                        </MDButton>
                                    </Grid>
                                </>
                            }
                        </Grid>
                        : null
                    }
                </td>
            </tr>
        )
    }

    renderTableWorkerDetail = () => {

        let temp = [];
        for (const [key, value] of Object.entries(this.state.workerDetail)) {
                temp.push(this.renderRigaWorkerDetail(value, key))
            }
        if (temp.length > 0) { return temp }
        return null;

    }

    renderRigaWorkerDetail = (el, index) => {


        if (el.length <= 0) { return null }
        if (!el[0].operaio) { return null }

        let operaio = el[0].operaio;
        let detail = this.workerDetailCostTypeArr(el);

        let searchString = operaio.nome + " " + operaio.cognome;

        if (!searchString.toLowerCase().includes(this.state.searchFilter.toLowerCase()) && this.state.searchFilter) {
            return null
        }
        let hourType = [];
        for (const [key, value] of Object.entries(detail[0])) {
            if (value > 0) {
                hourType.push(
                    <MDTypography variant="caption" fontWeight="medium">
                        {key.toUpperCase()} {value}H<br style={{ margin: 0, display:"block" }} />
                    </MDTypography>
                )
            }
        }

        let hourPrice=[]
        for (const [key, value] of Object.entries(detail[2])) {
            if (value > 0) {
                hourPrice.push(
                    <MDTypography variant="caption" fontWeight="medium">
                        {toPrice(value)}<br/>
                    </MDTypography>
                )
            }
        }



        return (
            <tr key={"worker-detail-" + index}>
                <td><MDTypography variant="caption" fontWeight="medium">{operaio.nome} {operaio.cognome}</MDTypography></td>
                <td>
                    {hourType}
                </td>
                {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?

                    <td>
                        {hourPrice}
                    </td>
:null}
                <td style={{ textAlign: "center" }}>
                    <MDTypography variant="caption" fontWeight="medium">
                        {detail[1]}H
                    </MDTypography>
                </td>
                {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                    <td style={{ textAlign: "center" }}>
                        <MDTypography variant="caption" fontWeight="medium">
                            {toPrice(detail[3])}
                        </MDTypography>
                    </td>
                    : null}
                {/*
                <td><MDTypography variant="caption" fontWeight="medium">{el.stato} {el.ore}H</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{toEuropeanDate(el.data)}</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{price}</MDTypography></td>
                <td>
                    <Grid container justifyContent={"flex-end"}>
                        <Grid item m={1}>
                            <MDButton color="success" iconOnly onClick={() => this.openDetail(el)}>
                                <Icon>visibility</Icon>
                            </MDButton>
                        </Grid>
                    </Grid>
                </td>
                */}
            </tr>
        )
    }

    workerDetailCostTypeArr = (worker) => {

        let sum = 0;
        let sumType = {
            ordinario: 0,
            straordinario: 0,
            permesso: 0,
            ferie: 0,
            malattia: 0,
            assenza: 0,
            sospeso: 0,
            notturno: 0,
            paternita:0
        };
        let sumPriceType = {
            ordinario: 0,
            straordinario: 0,
            permesso: 0,
            ferie: 0,
            malattia: 0,
            assenza: 0,
            sospeso: 0,
            notturno: 0,
            paternita:0,
        };

        // Calcola il filler totale per ogni giorno
        let fillerByDay = {};
        let costoFillerTotale = 0;
        worker.map((el) => {
            if (el.filler && el.filler > 0) {
                if (!fillerByDay[el.data]) {
                    fillerByDay[el.data] = 0;
                }
                fillerByDay[el.data] += el.filler;
                // Calcola il costo del filler usando il costo ordinario
                const costoOrdinario = el.operaio?.costo_orario || parseFloat(el.operaio.costo_orario);
                costoFillerTotale += el.filler * costoOrdinario;
            }
        });
        
        // Somma tutte le ore di filler
        let totalFiller = 0;
        for (const [key, value] of Object.entries(fillerByDay)) {
            totalFiller += value;
        }

        worker.map((el) => {
            if (el.stato == "ORDINARIO") {
                sum += newWorkerPrice(el, false)
                sumType.ordinario += el.ore;
                sumPriceType.ordinario += newWorkerPrice(el, false)
            }
            if (el.stato == "STRAORDINARI ") {
                sum += newWorkerPrice(el, false)
                sumType.straordinario += el.ore;
                sumPriceType.straordinario += newWorkerPrice(el, false)
            }
            if (el.stato == "PERMESSO") {
                sum += newWorkerPrice(el, false)
                sumType.permesso += el.ore;
                sumPriceType.permesso += newWorkerPrice(el, false)
            }
            if (el.stato == "FERIE") {
                sum += newWorkerPrice(el, false)
                sumType.ferie += el.ore;
                sumPriceType.ferie += newWorkerPrice(el, false)
            }
            if (el.stato == "MALATTIA") {
                sum += newWorkerPrice(el, false)
                sumType.malattia += el.ore;
                sumPriceType.malattia += newWorkerPrice(el, false)
            }
            if (el.stato == "ASSENZA") {
                sum += newWorkerPrice(el, false)
                sumType.assenza += el.ore;
                sumPriceType.assenza += newWorkerPrice(el, false)
            }
            if (el.stato == "SOSPESO") {
                sum += newWorkerPrice(el, false)
                sumType.sospeso += el.ore;
                sumPriceType.sospeso += newWorkerPrice(el, false)
            }
            if (el.stato == "NOTTURNO") {
                sum += newWorkerPrice(el, false)
                sumType.notturno += el.ore;
                sumPriceType.notturno += newWorkerPrice(el, false)
            }
            if (el.stato == "PATERNITA/MATERNITA") {
                sum += newWorkerPrice(el, false)
                sumType.paternita += el.ore;
                sumPriceType.paternita += newWorkerPrice(el, false)
            }
        })
        
        // Aggiungi le ore di filler all'ordinario
        sumType.ordinario += totalFiller;
        // Aggiungi il costo del filler all'ordinario
        sumPriceType.ordinario += costoFillerTotale;
        sum += costoFillerTotale;

        let totalH = sumType.ordinario + sumType.straordinario + sumType.permesso + sumType.ferie + sumType.malattia + sumType.assenza + sumType.sospeso + sumType.notturno + sumType.paternita
        return [sumType,totalH, sumPriceType, sum]

    }

    edit = (el) => {
        this.setState({editWorker:el})
    }

    delete = (el) => {
        if (window.confirm('Sicuro di voler eliminare?')) {
            ajax.ajaxDeleteStrapi("operai-commesses/" + el.id, this.deleteCallback)
            let temp = this.state.workers;
            for (let i = 0; i < temp.length; i++) {
                if (temp[i].id == el.id) {
                    temp.splice(i, 1);
                }
            }
            this.setState({ editWorker: null, workers: temp })

        }
    }

    openDetail = (el) => {
        this.setState({openGestioneManodopera:true , selectedCommessa:this.state.data.id, selectedDate:el.data})
    }

    saveWorkerDay = (el) => {
        let data = {
            data: {
                stato: el.stato,
                ore: el.ore,
            }
        }
        ajax.ajaxPutStrapi("operai-commesses/" + el.id, data, this.saveWorkerDayCallback)
    }

    saveWorkerDayCallback = (response) => {
        let temp = this.state.workers;
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].id == response.data.id) {
                temp[i].stato = response.data.stato;
                temp[i].ore = response.data.ore;
            }
        }
        this.setState({editWorker:null, workers:temp})
    }

    render() {

        


        if (this.state.openGestioneManodopera) {
            return <GestioneManodopera selectedCommessa={this.state.selectedCommessa} selectedDate={this.state.selectedDate} backFunction={() => this.setState({ openGestioneManodopera: false, selectedCommessa: null, selectedDate:null})}/>
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={this.state.data.nome + " - Manodopera"}
                    backButton={this.props.backFunction}
                />

                <Grid container>
                    <Grid container sx={{justifyContent:"flex-end"}}>
                  
                        <MDInput placeholder={"Cerca..."} sx={{ float: "right" }} onChange={(val) => { this.setState({ searchFilter: val.target.value }) }} />
                    </Grid>



                    <Grid item xs={12}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1, maxHeight: "35vh", overflow: "auto" }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <MDTypography variant="label" fontWeight="medium">ELENCO</MDTypography>
                            <table className={styles.tableOrdini}>
                                <tbody>
                                    {(this.state.workers) ?
                                        this.state.workers.map((el, index) => { return this.renderRigaWorker(el, index) })
                                        : null
                                    }
                                </tbody>
                            </table>
                        </MDBox>
                    </Grid>



                    <Grid item xs={12}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1, maxHeight: "35vh", overflow: "auto" }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <MDTypography variant="label" fontWeight="medium">RIEPILOGO</MDTypography>
                            <table className={styles.tableOrdini}>
                                <thead>
                                    <tr>
                                        <td>OPERAI</td>
                                        <td>ORE</td>
                                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                                            <td>COSTI</td> : null}
                                        <td style={{ textAlign: "center" }}>ORE TOTALI</td>
                                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                                            <td style={{ textAlign: "center" }}>COSTI TOTALI</td> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.workerDetail) ? this.renderTableWorkerDetail()
                                        : null
                                    }
                                </tbody>
                            </table>
                        </MDBox>
                    </Grid>


                </Grid>



                {this.state.editWorker ?
                    <Modal
                        open={this.state.editWorker != null}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClose={() => this.setState({ editWorker: null })}
                        style={{
                            margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <MDBox
                            bgColor={"white"}
                            borderRadius="lg"
                            p={2}
                            minWidth={400}
                        >
                            <MDBox
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                mx={2}
                                mt={-3}
                                p={2}
                                mb={1}
                                textAlign="center"
                            >
                                <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                    Modifica Assegnazione
                            </MDTypography>
                            </MDBox>

                            <Grid container={true} >
                                <Grid item sm={12} mb={2}>
                                    <MDInput fullWidth readOnly variant="standard" readOnly={true} value={this.state.editWorker.operaio.nome + " " + this.state.editWorker.operaio.cognome} />
                                </Grid>
                                <Grid item sm={12} mb={2}>
                                    <MDInput
                                        value={this.state.editWorker.stato}
                                        select
                                        fullWidth
                                        label={"Stato"}
                                        onChange={(e) => {
                                            this.setState(prevState => ({
                                                editWorker: {
                                                    ...prevState.editWorker,
                                                    stato: e.target.value
                                                }
                                            }))
                                        }}
                                    >
                                        {STATUS_WORKER.map((val, i) => {
                                            return (
                                                <MenuItem value={val} key={"select-status" + i}>{val}</MenuItem>
                                            )
                                        })}
                                    </MDInput>
                                </Grid>
                                <Grid item sm={12} mb={2}>
                                    <MDInput
                                        value={this.state.editWorker.ore}
                                        fullWidth
                                        label={"Ore"}
                                        type={"number"}
                                        min={1}
                                        max={12}
                                        onChange={(e) => {
                                            this.setState(prevState => ({
                                                editWorker: {
                                                    ...prevState.editWorker,
                                                    ore: e.target.value
                                                }
                                            }))
                                        }}
                                    />
                                </Grid>



                            </Grid>

                            <Grid container>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="error" onClick={() => this.delete(this.state.editWorker)}>
                                        <Icon style={{ marginRight: 10 }}>delete</Icon>
                                        elimina
                                </MDButton>
                                </Grid>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="success" ref={(ref) => this.saveButton = ref} onClick={() => this.saveWorkerDay(this.state.editWorker)}>
                                        <Icon style={{ marginRight: 10 }}>add</Icon>
                                        Salva
                                </MDButton>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Modal>
                    : null
                }
            </DashboardLayout>
        )
    }
}


